import { render } from "./IsoVoyage.vue?vue&type=template&id=6a43c9c9"
import script from "./IsoVoyage.vue?vue&type=script&lang=js"
export * from "./IsoVoyage.vue?vue&type=script&lang=js"

import "./IsoVoyage.vue?vue&type=style&index=0&id=6a43c9c9&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__